import React from "react";

import * as typography from "@client/shared/typography";
import * as utils from "@client/utils";

import {Prose} from "@client/components/Prose";
import * as components from "@client/site/components";
import * as forms from "@client/site/forms";
import {classNames, server} from "@reactivated";

export const Template = (props: server.core.templates.LeadCandidateUpload) => {
    const intro = `# ${props.title}
Logged in as: **${props.username}**

Use **Tab** to move to the next cell. 

On the last cell, press **Tab** again to add another row automatically. At any
time, you can press **Enter** to submit the leads and process them. Do so often
to avoid losing your work.

When you focus on a dropdown, like **Type** or **State**, type the first few
letters of the state to auto select it. Try it: navigate to **State** and type
**Fl** for Florida.

Some guidance on the fields below.

`;

    const changes = `
## Changes

- 2020-03-23: added Physician lead type. This is for **MD** degrees only. Just because they list Dr. does not make them a physician.
- 2020-03-22: added tags field
- 2020-02-19: city is now optional.
- 2020-02-19: re-ordered fields to match spreadsheet.
`;

    const help =
        intro +
        props.form_set.empty_form.iterator
            .map((fieldName) => {
                const field = props.form_set.empty_form.fields[fieldName];

                if (field.help_text === "") {
                    return "";
                }
                return `**${field.label}**: ${field.help_text ?? ""}`;
            })
            .join("\n\n") +
        changes;

    const hasErrors = (() => {
        for (const form of props.form_set.forms) {
            if (form.errors != null) {
                return true;
            }
        }
        return false;
    })();

    React.useEffect(() => {
        if (hasErrors === false) {
            document.querySelector<HTMLInputElement>("table input")?.focus();
        }
    }, []);

    return (
        <components.Layout title={props.title} narrow="liquid">
            <form
                noValidate
                method="POST"
                action=""
                className={classNames("space-y-[15px] flex flex-col", "tight-form")}
                encType="multipart/form-data"
            >
                <forms.CSRFToken />
                <Prose text={help} />
                <forms.FormSet formSet={props.form_set}>
                    {({addForm, formSet}) => (
                        <>
                            <div tabIndex={0} onFocus={() => addForm()} />
                            <typography.Button
                                submit
                                name="submit"
                                disabled={formSet.forms.length === 0}
                            >
                                Submit
                            </typography.Button>
                        </>
                    )}
                </forms.FormSet>
                <typography.Subtitle>Recent leads</typography.Subtitle>
                <typography.Table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Email</th>
                            <th>Full name</th>
                            <th>Created at</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.leads.map((lead) => (
                            <tr key={lead.id}>
                                <td>{lead.id}</td>
                                <td>{lead.lead_email}</td>
                                <td>{lead.full_name}</td>
                                <td>
                                    {utils.formatDistanceToNow(lead.created_at)} ago
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </typography.Table>
            </form>
        </components.Layout>
    );
};
